import Component from '@glimmer/component';
import { service } from '@ember/service';
import type PartnerService from 'tio-employee/services/partner';

const ZENDESK_HELP_CENTER = 'https://tio.zendesk.com/hc/en-us';
const PRIVACY_POLICY = 'https://www.tuition.io/privacy-policy';
const TERMS_OF_SERVICE = 'https://www.tuition.io/terms-of-service';

/** The design's fine print, verbatim. */
const COURSE_CASH_DISCLOSURE =
  'CourseCa$h™ Visa® Commercial cards are powered by Stripe and issued by Celtic Bank.';

export interface BetaHomeSiteFooterSignature {
  Element: HTMLElement;
}

/**
 * Beta home page footer.
 *
 * Design: "Powered by tuition.io" over a partner-configurable tagline and
 * copyright, a Contact and a Legal column, then a rule and the CourseCa$h
 * disclosure. Sits on --surface-2, so it picks up the co-brand tint.
 */
export default class BetaHomeSiteFooter extends Component<BetaHomeSiteFooterSignature> {
  @service declare partner: PartnerService;

  /**
   * GAP (partner-tagline): the design shows "Partner Tagline can be
   * configurable by partner." as a placeholder. There is no tagline field on
   * companySettings, so nothing to read yet — the row is omitted rather than
   * shipping the placeholder copy to real users.
   */
  get partnerTagline(): string | null {
    return null;
  }

  get copyright(): string {
    return `©${new Date().getFullYear()} Tuition.io`;
  }

  <template>
    {{! template-lint-disable no-bare-strings }}
    <footer class="tio-beta-home__footer" data-test-beta-footer ...attributes>
      <div class="tio-beta-home__footer-top">
        <div class="tio-beta-home__footer-brand">
          <div class="tio-beta-home__powered">
            <span>Powered by</span>
            <span class="tio-beta-home__powered-mark">tuition.io</span>
          </div>

          {{#if this.partnerTagline}}
            <p class="tio-beta-home__footer-tagline">{{this.partnerTagline}}</p>
          {{/if}}

          <p class="tio-beta-home__footer-copyright">{{this.copyright}}</p>
        </div>

        <div class="tio-beta-home__footer-cols">
          <div class="tio-beta-home__footer-col">
            <div class="tio-beta-home__footer-col-title">Contact</div>
            <div class="tio-beta-home__footer-links">
              <a
                href={{ZENDESK_HELP_CENTER}}
                target="_blank"
                rel="noopener noreferrer"
                class="tio-beta-home__footer-link"
              >support</a>
              <a
                href={{ZENDESK_HELP_CENTER}}
                target="_blank"
                rel="noopener noreferrer"
                class="tio-beta-home__footer-link"
              >help</a>
            </div>
          </div>

          <div class="tio-beta-home__footer-col">
            <div class="tio-beta-home__footer-col-title">Legal</div>
            <div class="tio-beta-home__footer-links">
              <a
                href={{PRIVACY_POLICY}}
                target="_blank"
                rel="noopener noreferrer"
                class="tio-beta-home__footer-link"
              >privacy policy</a>
              <a
                href={{TERMS_OF_SERVICE}}
                target="_blank"
                rel="noopener noreferrer"
                class="tio-beta-home__footer-link"
              >terms of service</a>
            </div>
          </div>
        </div>
      </div>

      <div class="tio-beta-home__footer-fine">{{COURSE_CASH_DISCLOSURE}}</div>
    </footer>
  </template>
}
